import * as fileApi from "../../api/fileApi";

export function download(id, params) {
  return function () {
    return fileApi.download(id, params).catch((error) => {
      throw error;
    });
  };
}
